<template>
    <footer class="gh-footer">
        <div class="gh-footer__top">
            <div class="container gh-footer__container">
                <div class="row">
                    <div class="col-xs-6 col-sm-3">
                        <div class="menu">
                            <h3 class="gh-footer__heading">About Us</h3>
                            <ul class="gh-footer__menu">
                                <li class="gh-footer__item"><a class="gh-footer__link" href="/about-us" target="_blank">Overview</a></li>
                                <li class="gh-footer__item"><a class="gh-footer__link" href="/about-us#why-learn-with-mha" target="_blank">Why learn with MHA</a></li>
                                <li class="gh-footer__item"><a class="gh-footer__link" href="/about-us#learning-formats" target="_blank">Learning Formats</a></li>
                                <li class="gh-footer__item"><a class="gh-footer__link" href="/about-us#industry-partners" target="_blank">Industry Partners</a></li>
                                <li class="gh-footer__item"><a class="gh-footer__link" href="/about-us#our-values" target="_blank">Our Values</a></li>
                            </ul>
                        </div>

                        <div v-if="isMobile" class="menu">
                            <h3 class="gh-footer__heading">Support</h3>
                            <ul class="gh-footer__menu">
                                <li class="gh-footer__item"><a href="/faqs" class="gh-footer__link" target="_blank">FAQs</a></li>
                                <li class="gh-footer__item"><a href="/contact" class="gh-footer__link" target="_blank">Contact Us</a></li>
                            </ul>
                        </div>
                    </div>

                    <div class="col-xs-6 col-sm-3">
                        <div class="menu">
                            <h3 class="gh-footer__heading">Catalogue</h3>
                            <ul class="gh-footer__menu">
                                <li class="gh-footer__item"><button @click="handleCatalogueLinkClick('text')" class="gh-footer__link">Text Courses</button></li>
                                <li class="gh-footer__item"><button @click="handleCatalogueLinkClick('video')" class="gh-footer__link">Video Courses</button></li>
                                <li class="gh-footer__item"><button @click="handleCatalogueLinkClick('collections')" class="gh-footer__link">Collections</button></li>
                                <!-- <li class="gh-footer__item"><a href="/credentials" class="gh-footer__link">Credentials</a></li> -->
                            </ul>
                        </div>

                        <div class="menu">
                            <h3 class="gh-footer__heading">Membership</h3>
                            <ul class="gh-footer__menu">
                                <!--  -->
                                <li class="gh-footer__item"><a href="/login" class="gh-footer__link" target="_blank">Learner Login</a></li>
                            </ul>
                        </div>

                        <div class="menu" v-if="isMobile">
                            <router-link to="/" class="gh-footer__logo">
                                <img src="/images/app/MHA-Logo-2017-LA[R].svg" alt="Mental Health Academy Logo">
                            </router-link>
                        </div>
                    </div>

                    <div class="col-xs-6 col-sm-3" v-if="!isMobile">
                        <div class="menu">
                            <h3 class="gh-footer__heading">Support</h3>
                            <ul class="gh-footer__menu">
                                <li class="gh-footer__item"><a href="/faqs" class="gh-footer__link" target="_blank">FAQs</a></li>
                                <li class="gh-footer__item"><a href="/contact" class="gh-footer__link" target="_blank">Contact Us</a></li>
                            </ul>
                        </div>
                    </div>

                    <div class="col-xs-6 col-sm-3" v-if="!isMobile">
                        <router-link to="/" class="gh-footer__logo">
                            <img src="/images/app/MHA-Logo-2017-LA[R].svg" alt="Mental Health Academy Logo">
                        </router-link>
                    </div>
                </div>
            </div>
        </div>

        <div class="gh-footer__bottom">
            <div class="container">
                <div class="row">
                    <div class="col-xs-12 col-sm-5 cards">
                        <ul class="gh-list">
                            <li class="gh-list__item"><i class="gh-list__icon fa fa-cc-mastercard" aria-hidden="true"></i></li>
                            <li class="gh-list__item"><i class="gh-list__icon fa fa-cc-visa" aria-hidden="true"></i></li>
                        </ul>
                    </div>

                    <div class="col-xs-12 col-sm-7 terms">
                        <ul class="gh-list">
                            <li class="gh-list__item"><router-link class="gh-list__link" to="/terms" target="_blank">Terms and Conditions</router-link></li>
                            <li class="gh-list__item"><router-link class="gh-list__link" to="/privacy" target="_blank">Privacy Notice</router-link></li>
                        </ul>

                        <p class="copyrights">
                            <span>© {{ copyrightYear }} Mental Health Academy. All rights reserved.</span>
                            <span>Site by <a :href="$root.greenhat" target="_blank" title="Greenhat Brisbane Web Design">Greenhat | Brisbane Web Design</a></span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </footer> <!-- End Footer -->
</template>

<script>
    import { format } from 'date-fns';
    export default {
        computed: {
            isCataloguePage() {
                return this.$route.name === 'public.catalogue' || this.$route.path === '/catalogue';
            },
            copyrightYear() {
                return '2017-' + format(new Date(), 'YY' );
            },
            linksToHide () {
                return this.$route.meta.linksToHide
            },
            isMobile() {
              return this.$store.state.ui.device === 'mobile'
            }
        },

        methods: {
            toAboutUsSection(section) {
                this.$router.push(`/about-us#${section}`);
            },

            handleCatalogueLinkClick(filter) {
                let criteria = {}

                if (filter === 'text' || filter === 'video') {
                    criteria = {topics: [], formats: [filter], levels: []};
                } else if (filter === 'collections') {
                    criteria = {topics: [], formats: [], levels: ['collections']}
                } else if (filter === 'credentials') {
                    criteria = {topics: [], formats: [], levels: ['credential']}
                }

                if (this.isCataloguePage) {
                    this.$store.dispatch('catalogue/findCoursesByCriteria', {criteria});
                } else {
                    const routeData = this.$router.resolve({name: 'public.catalogue', query: {filter}});

                    window.open(routeData.href, '_blank');
                }
            },

            showLink(link) {
                if (! this.linksToHide) {
                    return true
                }
                return this.linksToHide.indexOf(link) < 0
            }
        }
    }
</script>
<style lang="scss" scoped>
    .gh-footer__logo {
        margin-top: 0;
    }
</style>
